import { render, staticRenderFns } from "./TaskSet.vue?vue&type=template&id=f2e358ae&scoped=true&"
import script from "./TaskSet.vue?vue&type=script&lang=js&"
export * from "./TaskSet.vue?vue&type=script&lang=js&"
import style0 from "./TaskSet.vue?vue&type=style&index=0&id=f2e358ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e358ae",
  null
  
)

export default component.exports